export var SLICE = "ui";
export var PUSH_ROUTE = "".concat(SLICE, "/PUSH_ROUTE");
export var ADD_NOTIFICATION = "".concat(SLICE, "/ADD_NOTIFICATION");
export var CLOSE_NOTIFICATION = "".concat(SLICE, "/CLOSE_NOTIFICATION");
export var START_REQUEST_LOADING = "".concat(SLICE, "/START_REQUEST_LOADING");
export var END_REQUEST_LOADING = "".concat(SLICE, "/END_REQUEST_LOADING");
export var UI_MODAL = "UI_MODAL";
export var OPEN_UI_MODAL = "".concat(SLICE, "/OPEN_").concat(UI_MODAL);
export var CLOSE_UI_MODAL = "".concat(SLICE, "/CLOSE_").concat(UI_MODAL);
export var UPLOAD_FILES_MODAL = "UPLOAD_FILES_MODAL";
export var FOLDER_CREATE_MODAL = "FOLDER_CREATE_MODAL";
export var DELETE_REPORT_MODAL = "DELETE_REPORT_MODAL";
export var UPLOAD_REPORT_MODAL = "UPLOAD_REPORT_MODAL";
export var APPROVE_REPORT_MODAL = "APPROVE_REPORT_MODAL";
export var REJECT_REPORT_MODAL = "REJECT_REPORT_MODAL";
export var NotificationTypeEnum = Object.freeze({
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning"
});
export var DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
export var POLLING_NOTIFICATION_CLOSE_TIMEOUT = 10000;
export var DEFAULT_ROUTE_CHANGE_TIMEOUT = 5000;
export var FORM = "FORM";
export var UPDATE_FORM_VALUE = "".concat(SLICE, "/UPDATE_").concat(FORM);
export var RESET_FORM_VALUES = "".concat(SLICE, "/RESET_").concat(FORM);
export var TAB_VALUE = "TAB_VALUE";
export var UPDATE_TAB_VALUE = "".concat(SLICE, "/UPDATE_").concat(TAB_VALUE);
export var GET_TAB_VALUE = "".concat(SLICE, "/GET_").concat(TAB_VALUE);

//# sourceMappingURL=types.js.map